import on from "../util/on";
import breakpoints from "../util/breakpoints";
import throttle from "../util/throttle";
import Swiper, { Scrollbar, Mousewheel, Lazy, Controller } from "swiper";
Swiper.use([Scrollbar, Mousewheel, Lazy, Controller]);

export default class Cards {
  constructor() {
    this.cardRefresh = document.querySelector(".js-card-refresh");
    this.carousel = "";
    this.carouselInit = false;

    this.setupSlider = this.setupSlider.bind(this);
  }

  init() {
    this.setupSlider();
    this.events();
  }

  events() {
    on(".js-cards", "click", ".js-card-refresh", this.refreshCards);
    window.addEventListener("resize", throttle(this.setupSlider, 300));
  }

  setupSlider() {
    if (breakpoints.small.matches) {
      if (!this.carouselInit) {
        this.carouselInit = true;
        this.carousel = new Swiper(".js-cards", {
          loop: false,
          slidesPerView: "auto",
          scrollbar: {
            el: ".o-carousel-scrollbar",
            hide: false,
          },
          containerModifierClass: "c-cards-",
          slideClass: "c-cards__item",
          slideActiveClass: "-active",
          slideVisibleClass: "-visible",
          slideNextClass: "-next",
          slidePrevClass: "-prev",
          wrapperClass: "c-cards__wrapper",
        });
      } else {
        if (this.carousel) {
          this.carousel.destroy();
        }
        this.carouselInit = false;
      }
    }
  }

  refreshCards(e) {
    e.preventDefault();

    let elems = document.querySelectorAll(".js-card-item.--hidden");
    let activeElems = document.querySelectorAll(".js-card-item:not(.--hidden)");

    elems.forEach(element => {
      element.classList.remove("--hidden");
    });

    activeElems.forEach(element => {
      element.classList.add("--hidden");
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/components/cards.js